import { serialize } from "../../../helpers/helpers";
import { apiRequest } from "../../../apiHelper/apiRequest";

const get_users_list = async params => {
  return apiRequest(
    "/users/list?" + serialize(params),
    {
      'method': "GET"
    },
    'ptp_client'
  );
}

const get_users_info = async id => {
  return apiRequest(
    `/users/get-user-info/${id}`,
    {
      'method': "GET"
    },
    'ptp_client'
  );
}

const toggle_admin_active = async id => {
  let responce = await apiRequest(
    `/users/toggle-active/${id}`,
    {
      'method': "PUT",
    },
    'ptp_client'
  );

  if (typeof (responce.id) !== 'undefined' && responce.id)
    return responce;
  else
    return 0;
}

const toggle_employee_active = async id => {
  let responce = await apiRequest(
    `/users/toggle-employee-active/${id}`,
    {
      'method': "PUT",
    },
    'ptp_client'
  );

  if (typeof (responce.id) !== 'undefined' && responce.id)
    return responce;
  else
    return 0;
}

const usersApi = {
  get_users_list,
  get_users_info,
  toggle_admin_active,
  toggle_employee_active,
};

export default usersApi;